/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "./components/tripOverview/Common/Loader";
import ProfilePage from "./components/tripOverview/profilePage";
import { useAuth0 } from '@auth0/auth0-react';
import { HandleLogin } from "./atom/utilities/function";
import Helper from './Helper';

const OverviewRouteConfig = () => {
    const [flag, setFlag] = useState(false)
    const { loginWithRedirect, logout, isAuthenticated } = useAuth0();

    useEffect(() => {
        let url = window.location.href?.split("?")[1]?.split("&")[1]?.split("=")[1];
        if (url) {
            window.location.assign(`v1/${url}`);
            setFlag(false)
        } else if (window.location.href.includes('share')) {
            let splitUrl = window.location.href.split('=')[1]

            window.location.assign(`v1/share/${splitUrl}`)
        }
        else {
            if (window.location.pathname !== "/viewer/") {
                !isAuthenticated && window.location.assign('/viewer/')
            }
            setFlag(true)
        }
    }, [])
    return (
        <><Routes>
            <Route
                path="/*"
                element={
                    <React.Suspense fallback={<Loader content='Loading...' />}>
                        {isAuthenticated && flag ? <ProfilePage /> : flag ? <>{HandleLogin(Helper.loginWithRedirect, logout, isAuthenticated)}</> : <Loader content='Loading...' />}
                    </React.Suspense>
                }
            />
        </Routes>

        </>
    )
};
export default OverviewRouteConfig